import { makeRequest } from '../../../api/makeRequest';

export const deleteOrCancelCtn = (childrenCtn, forceFlag = true) => makeRequest({
  url: '/sebTariff/deleteOrCancel/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  method: 'post',
  data: {
    ctn: childrenCtn,
    force: forceFlag,
  },
});

export const getPriceAfterDelete = (ctn, childCtn) => makeRequest({
  url: '/limitFamily/getPriceAfterDelete/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  method: 'post',
  data: {
    mainCtn: ctn,
    childCtn,
  },
});
